// ...existing code...
import React, { useCallback, useRef, useState } from 'react';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import { useDispatch } from "react-redux";
import { Button, Menu, MenuItem } from '@mui/material';
import { actions } from './Reports.redux';
import { useNavigate } from '@tanstack/react-router';
import DeletePopover from 'components/DeletePopover';



const TemplatesCell = (props) => {
	const { column, row } = props;
	const id                              = row.template_id,
		  dispatch                        = useDispatch(),
		  navigate                        = useNavigate(),
		  actionAnchor                    = useRef(null),
		  [ actionsOpen, setActionsOpen ] = useState(false);


	const beforeDeleteTemplate = useCallback(() => {
		dispatch(actions.setState({ loading: true }));
	}, [ dispatch ]);

	const afterDeleteTemplate = useCallback(() => {
		dispatch(actions.loadTemplates());
		setActionsOpen(false);
	}, [ dispatch ]);


	const handleNavigate = useCallback(() => {
		navigate({ to: `/reports/edit-layout/${id}` });
	}, [ navigate, id ]);



	if(column.name === 'actions') {
		return (
			<Table.Cell {...props}>
				<Button variant="outlined" size="large" onClick={() => setActionsOpen(true)} ref={actionAnchor}>
					...
				</Button>
				<Menu open={actionsOpen} onClose={() => setActionsOpen(false)} anchorEl={actionAnchor.current}>
					<MenuItem>
						<DeletePopover
							objectType="TEMPLATE"
							objectID={id}
							afterDelete={afterDeleteTemplate}
							beforeDelete={beforeDeleteTemplate}
						>
							<Button variant="text" size="large" color="error">Delete Layout</Button>
						</DeletePopover>
					</MenuItem>
				</Menu>

			</Table.Cell>
		);
	}

	return (
		<Table.Cell {...props} onClick={handleNavigate} />
	);
};


export default TemplatesCell;

